<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  @if (isPageDisabled) {
    <div class="offset-md-1 col-md-10 ziro-page-alert alert alert-warning" data-automation="ziro-page-reroute-alert">
      <div class="ms-3" [innerHTML]="'tkey;admin.microsoft.audit.settings.description' | escapeHtml"></div>
    </div>
  }
  <div class="col-md-10 offset-md-1 pb-2" [hidden]="isLoading || isPageDisabled">
    <ziro-breadcrumbs></ziro-breadcrumbs>

    <div class="mb-3 list-group list-group-striped border-rad-all-12 card-shadow">
      <div class="list-group-item position-relative">
        <ziro-general-settings-text [fieldId]="'daysToKeepAuditRecords'"></ziro-general-settings-text>
      </div>
    </div>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
